var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.current_page_id && _vm.sub_pages)?_c('SubPages',{staticClass:"shop-menus",attrs:{"pages":_vm.sub_pages,"current_page_id":_vm.current_page_id}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }